<template>
  <div class="col-12 col-lg-4  ">
    <img :src="data.img" alt="" class="p-5 mx-auto d-block" width="80%">
    <h3 class="text-center" style="color: white;">{{data.titulo}}</h3>
    <h4 class="text-center w-100" style="display: inline; color: white; margin-right: auto; margin-left: auto;" >{{data.numero}}</h4>
    <p class="px-4 text-justify" style="color: white;" v-html="data.descripcion"></p>
  </div>
</template>

<script>
  export default {
    name: "CardGradient",
    props: {
      data: {type: Object, required: true}
    }
  }
</script>

<style scoped>

</style>
